import React, { useEffect } from "react";
import { Badge, Dropdown, Menu, Button } from "antd";
import { Link, useParams, useLocation } from "react-router-dom";

import { EllipsisOutlined } from "@ant-design/icons";
import { viewAmenitiesList } from "../../Redux/Actions/amenitiesActions";
import { useDispatch, useSelector } from "react-redux";
import TableComponent from "../../Global Functions/tableComponents";
import DeleteFunction from "../../Global Functions/deleteFunction";
import { ToFirstCapital } from "../../Utils/helpers";

const ViewAmenities = () => {
  const { id } = useParams();
  const location = useLocation();

  const amenityName = location.state?.amenityName || "Loading";

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const dispatch = useDispatch();

  useEffect(() => {
    const amenityData = {
      page: 1,
      limit: 100,
      category_id: "",
      unit_id: "",
      amenity_id: id,
    };
    dispatch(viewAmenitiesList(amenityData));
  }, [dispatch, id]);

  const { amenities } = useSelector((state) => state.amenities);

  const columns = [
    {
      title: "Sr. No.",
      align: "center",
      key: "sr no.",
      render: (_, __, index) => index + 1,
    },
    {
      title: " Name",
      align: "center",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Image",
      align: "center",
      dataIndex: "image",
      key: "image",
      render: (record) => <img style={{ width: "50px" }} src={record} alt="" />,
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9", // Light gray border
            borderRadius: "10px", // Rounded edges
          }}
        >
          <Badge
            color={status === "active" ? "green" : "red"}
            text={ToFirstCapital(status)}
            background
          ></Badge>
        </span>
      ),
    },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              {canEdit &&
                <Menu.Item key="edit">
                  <Link to={`/amenities/${record._id}/sub/edit/`}>Edit</Link>
                </Menu.Item>
              }
              <Menu.Item
                key="delete"
                style={{ color: "red" }}
                onClick={async () =>
                  await DeleteFunction("/amenity/remove", record._id)
                }
              >
                Delete
              </Menu.Item>
            </Menu>
          }
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return (
    <TableComponent
      h3heading={amenityName}
      buttonhead="Go Back"
      navigateTo={`/amenities`}
      buttonhead2={canAdd ? "Add Sub Amenities" : null}
      navigateTo2={canAdd ? `/amenities/${id}/sub/add` : null}
      columns={columns}
      dataSource={Array.isArray(amenities?.data) ? amenities.data : []}
      rowKey="_id"
    ></TableComponent>
  );
};

export default ViewAmenities;
